(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sun-fabric-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sun-fabrics]').forEach((section) => {
    section.querySelectorAll('[data-fabric-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const group = tab.dataset.fabricTab;
        section.querySelectorAll('[data-fabric-tab]').forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        section.querySelectorAll('[data-fabric-panel]').forEach((panel) => {
          const active = panel.dataset.fabricPanel === group;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
